
/**
 * 평점별 분포
 */
export type GetCourseReviewStats200RatingDistribution = {
  five: number;
  four: number;
  one: number;
  three: number;
  two: number;
};
